// Mensagens rapidas: textos prontos que entram na caixa de mensagem.
// Digitar "/" seguido do atalho abre as sugestoes; nada e enviado sem o atendente confirmar.

const MAX_SUGGESTIONS = 8;

function normalize(value) {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

// "/orc" -> "orc"; "/" -> ""; qualquer outro texto -> null (sem sugestoes).
export function getSlashQuery(text) {
  const match = /^\/([^\s/]*)$/.exec(String(text ?? ''));
  return match ? match[1] : null;
}

export function filterQuickReplies(replies, query) {
  const term = normalize(query);
  const list = Array.isArray(replies) ? replies : [];
  if (!term) return list.slice(0, MAX_SUGGESTIONS);
  const startsWith = list.filter((item) => normalize(item.atalho).startsWith(term));
  const contains = list.filter((item) => !startsWith.includes(item)
    && (normalize(item.atalho).includes(term) || normalize(item.texto).includes(term)));
  return [...startsWith, ...contains].slice(0, MAX_SUGGESTIONS);
}

// {nome} vira o primeiro nome do contato; se o contato so tem telefone, some.
export function fillQuickReply(text, contact) {
  const rawName = String(contact?.name || '').trim();
  const firstName = rawName && !/^\+?[\d\s()-]+$/.test(rawName) ? rawName.split(/\s+/)[0] : '';
  const withName = firstName
    ? String(text ?? '').replace(/\{\s*nome\s*\}/gi, firstName)
    : String(text ?? '').replace(/,?[ \t]*\{\s*nome\s*\}/gi, '');
  return withName
    .replace(/[ \t]+([,.!?])/g, '$1')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}
